import React from 'react';
import { Popover } from 'react-bootstrap';
import { BSOverlay } from '~/components/Bootstrap';
import { ProviderSpecialtyType } from '~/util/providerUtils';

interface ProviderSpecialtyProps {
    specialties?: undefined | ProviderSpecialtyType[];
}

export function ProviderSpecialty({ specialties }: ProviderSpecialtyProps) {
    if (!specialties || specialties.length === 0) return <div>&nbsp;</div>;
    const hasPrimary = specialties.find((specialty) => specialty.isPrimary);
    const first = hasPrimary || specialties[0];
    return (
        <div>
            <span>{first.name.length > 30 ? `${first.name.substring(0, 30)}...` : first.name}</span>
            {specialties.length > 1 || first.name.length > 30 ? (
                <span className="ms-2">
                    <BSOverlay
                        placement="top"
                        delay={{ show: 1500, hide: 0 }}
                        overlay={
                            <Popover>
                                <Popover.Body>
                                    <ul className="specialties-list">
                                        <li>{first.name}</li>
                                        {Array.isArray(specialties) &&
                                            specialties
                                                .filter((x) => x.id !== first.id)
                                                .map((specialty) => (
                                                    <li key={specialty.id}>{specialty.name}</li>
                                                ))}
                                    </ul>
                                </Popover.Body>
                            </Popover>
                        }
                    >
                        <i className="fa-solid fa-user-md">
                            <span className="sr-only">Specialties</span>
                        </i>
                    </BSOverlay>
                </span>
            ) : null}
        </div>
    );
}
